import SubcategoryPage from '@/components/template/SubcategoryPage';

const TokyoOval = () => {
  const products = [
    {
      title: "Tokyo Oval Model 1",
      imageSrc: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-oval/model-1"
    },
    {
      title: "Tokyo Oval Model 2",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-oval/model-2"
    },
    {
      title: "Tokyo Oval Model 3",
      imageSrc: "https://images.unsplash.com/photo-1554302891-c04b1941b963?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-oval/model-3"
    },
    {
      title: "Tokyo Oval Model 4",
      imageSrc: "https://images.unsplash.com/photo-1615800001964-5afd02a82171?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-oval/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Tokyo Oval"
      description="Elegantna ovalna ogledala z japonsko inspiracijo. Prefinjene linije in brezčasna eleganca za vsak prostor."
      heroImage="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TokyoOval;